import { useFormContext } from 'react-hook-form';

const CommentInput = () => {
    const { register, formState: { errors } } = useFormContext();

    return (
        <div className="mb-4">
            <label className="block text-[#072320] text-sm font-semibold mb-1">
                Comment <span className="text-red-500">*</span>
            </label>
            <textarea
                {...register('comment')}
                placeholder="Write your thoughts here..."
                className={`w-full px-4 py-3 text-sm border rounded-lg shadow-sm focus:outline-none transition duration-200 ${
                    errors.comment
                        ? 'border-red-500 focus:ring-red-500'
                        : 'border-gray-300 focus:ring-[#00A762]'
                }`}
                rows={4}
            />
            {errors.comment && (
                <p className="text-sm text-red-500 mt-1">{errors.comment.message}</p>
            )}
        </div>
    );
};

export default CommentInput;
